import { forwardRef } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import CommentHeader from "./Header";
import Reactions from "./Reactions";

import { createCommentElementId } from "../utils";

const Comment = forwardRef(
  (
    {
      user,
      comment,
      reactions,
      info,
      actions,
      className,
      children,
      onAddReaction,
      onRemoveReaction,
    },
    ref
  ) => (
    <div
      {...{ ref }}
      id={createCommentElementId(comment)}
      className={classNames(
        "neeto-ui-bg-white neeto-ui-rounded-md neeto-ui-border-gray-300 neeto-molecules-comments-node mb-4 w-full border",
        className
      )}
    >
      <CommentHeader {...{ actions, comment, info, user }} />
      <div className="neeto-molecules-comments-node__inner p-4">
        {children}
        {reactions !== false && (
          <Reactions
            {...{ reactions }}
            onAdd={onAddReaction}
            onRemove={onRemoveReaction}
          />
        )}
      </div>
    </div>
  )
);

Comment.displayName = "Comment";
Comment.propTypes = {
  /** Object representing the user information  */
  user: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,

  /** Object representing the comment item.  */
  comment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,

  /** Array of reactions. Settings this to `false` will disable reactions for the item  */
  reactions: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),

  /**  Optional text label to be displayed in the header. */
  info: PropTypes.string,

  /**  Optional action items to be passed to the menuItems prop of the actions dropdown */
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      isVisible: PropTypes.bool,
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ),

  /**  Additional classes passed on to the board view. */
  className: PropTypes.string,

  /** Callback function triggered when a reaction (emoji) is added */
  onAddReaction: PropTypes.func,

  /** Callback function triggered when a reaction (emoji) is removed*/
  onRemoveReaction: PropTypes.func,
};

export default Comment;
